export default "__VITE_ASSET__BC0RTuc4__"